import { render, staticRenderFns } from "./attached-form.vue?vue&type=template&id=4344dc34&scoped=true&"
import script from "./attached-form.vue?vue&type=script&lang=js&"
export * from "./attached-form.vue?vue&type=script&lang=js&"
import style0 from "./attached-form.vue?vue&type=style&index=0&id=4344dc34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4344dc34",
  null
  
)

export default component.exports